import script from "./DBOptionsStat.vue?vue&type=script&setup=true&lang=ts"
export * from "./DBOptionsStat.vue?vue&type=script&setup=true&lang=ts"

import "./DBOptionsStat.vue?vue&type=style&index=0&id=58ba7dde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58ba7dde"]])

export default __exports__